import { SbsStory } from './SbsStory.jsx';
import { SbsMission } from './SbsMission';
import { SbsVision } from './SbsVision';

import './Sbs.css';

const Sbs = ({ userId }) => {
  return (
    <div className="side-by-side-wrapper">
      <SbsStory />
      <SbsMission userId={userId} />
      <SbsVision />
    </div>
  );
};

export default Sbs;
